import { c as _c } from "react/compiler-runtime";
import type { InterfaceToken } from '@morpho-org/dapp-core';
import { Avatar, NetworkAvatar as Network } from '@morpho-org/ui-v6/client';
import { memo } from 'react';
interface TokenNetworkAvatarProps {
  asset: InterfaceToken;
}
const TokenNetworkAvatar = t0 => {
  const $ = _c(8);
  const {
    asset
  } = t0;
  let t1;
  if ($[0] !== asset.logoURI) {
    t1 = <Avatar src={asset.logoURI} size="medium" />;
    $[0] = asset.logoURI;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      size: "xsmall"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== asset.chain.id) {
    t3 = <div className="absolute right-[-4px] bottom-0 z-1 h-[14px] w-[14px]"><Network chainId={asset.chain.id} srcAvatarProps={t2} /></div>;
    $[3] = asset.chain.id;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t1 || $[6] !== t3) {
    t4 = <div className="mr-2xs relative inline-block">{t1}{t3}</div>;
    $[5] = t1;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
export default memo(TokenNetworkAvatar);